import axios from "axios";
import React, { useState, useEffect } from "react";
import Button from "../components/Button";
import SnackBar from "../components/SnackBar";
import image from "../images/bg1.webp";
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography, Link } from '@material-ui/core';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import PhoneIcon from '@material-ui/icons/Phone';
import MailIcon from '@material-ui/icons/Mail';

const useStyles = makeStyles((theme) => ({
	root: {
	  flexGrow: 1,
	  padding: theme.spacing(4),
	},
	icon: {
	  marginRight: theme.spacing(1),
	  fontSize: '1.5rem',
	},
  }));

const Contact = () => {
	const classes = useStyles();
	const [show, setShow] = useState(false);
	const vh = window.innerHeight / 100;
	useEffect(() => {
		window.scrollTo(0, 12.5 * vh);
	}, []);
	const [user, setUser] = useState({
		name: "",
		email: "",
		message: "",
	});
	const handleChange = (e) => {
		const { name, value } = e.target;
		setUser({
			...user,
			[name]: value,
		});
	};
	const handleSubmit = async (e) => {
		e.preventDefault();
		setUser({
			name: "",
			email: "",
			message: "",
		});
		console.log(user);
		try {
			const newUser = await axios.post(
				"https://myownrestfullapi.herokuapp.com/sendmail",
				user
			);
		} catch (error) {
			console.log(error);
		}
		setShow(true);
		setTimeout(() => {
			setShow(false);
		}, 2500);
	};
	return (
		<>
		<div className={classes.root} style={{
				backgroundColor: '#eddbab',
			}}>
		<Grid container spacing={3} alignItems="center">
		  <Grid item xs={12} alignItems="center">
			<Typography variant="h3" align="center">Contact Information</Typography>
		  </Grid>
		  <Grid item xs={12} sm={6}>
			<Grid container spacing={1} alignItems="center">
			  <Grid item>
				<InstagramIcon className={classes.icon} />
			  </Grid>
			  <Grid item>
				<Typography>Instagram ID: <Link href="https://www.instagram.com/symcosci_2k24">symcosci_2k24</Link></Typography>
			  </Grid>
			</Grid>
		  </Grid>
		  <Grid item xs={12} sm={6}>
			<Grid container spacing={1} alignItems="center">
			  <Grid item>
				<FacebookIcon className={classes.icon} />
			  </Grid>
			  <Grid item>
				<Typography>Facebook ID: <Link href="https://www.instagram.com/symcosci_2k24">symcosci</Link></Typography>
			  </Grid>
			</Grid>
		  </Grid>
		  <Grid item xs={12} sm={6}>
			<Grid container spacing={1} alignItems="center">
			  <Grid item>
				<TwitterIcon className={classes.icon} />
			  </Grid>
			  <Grid item>
				<Typography>Twitter ID: <Link href="https://twitter.com/Symcosci_2k24">Symcosci_2k24</Link></Typography>
			  </Grid>
			</Grid>
		  </Grid>
		  
		  <Grid item xs={12} sm={6}>
			<Grid container spacing={1} alignItems="center">
			  <Grid item>
				<MailIcon className={classes.icon} />
			  </Grid>
			  <Grid item>
				<Typography>Email ID: <Link href="mailto:vijay@gmail.com">symcosci.mec@gmail.com</Link></Typography>
			  </Grid>
			</Grid>
		  </Grid>
		  <Grid item xs={12} sm={6}>
			<Grid container spacing={1} alignItems="center">
			  <Grid item>
				<PhoneIcon className={classes.icon} />
			  </Grid>
			  <Grid item>
				<Typography><b>Student Co-ordinators:</b> <br></br><Link href="tel:+9597996275">Mr.M.Vijayaprakash : 9597996275</Link><br></br><Link href="tel:+8870468660">Mr.A.Noorul Ashfaq : 8870468660</Link><br></br><Link href="tel:+8807568935">Ms.S.S.Karthika : 8807568935</Link></Typography>
			  </Grid>
			</Grid>
		  </Grid>
		  <Grid item xs={12} sm={6}>
			<Grid container spacing={1} alignItems="center">
			  <Grid item>
				<PhoneIcon className={classes.icon} />
			  </Grid>
			  <Grid item>
				<Typography><b>Faculty Co-ordinator:</b> <br></br><Link href="tel:+9944085437">Mr.S.R.Sridhar, AP/CSE : 9944085437</Link></Typography>
			  </Grid>
			</Grid>
		  </Grid>
		</Grid>
	  </div>
		<section
			className="contact"
			style={{
				backgroundImage: `url(${image})`,
			}}
		>
			<div className="contact-box">
				<div className="contact-container">
					<div className="contact-head">Contact Us</div>
					<form className="contact-form" onSubmit={handleSubmit}>
						<input
							type="text"
							name="name"
							placeholder="Your Name"
							value={user.name}
							onChange={handleChange}
							required
						/>
						<input
							type="email"
							name="email"
							placeholder="Your Email"
							value={user.email}
							onChange={handleChange}
						/>
						<textarea
							name="message"
							placeholder="Your message here"
							value={user.message}
							onChange={handleChange}
							required
						></textarea>
						<Button
							text="Submit Response"
							type={"submit"}
							color="tertiary"
							style={{ color: "var(--bgcolor)" }}
						/>
					</form>
				</div>
			</div>
			{show && <SnackBar text="Response Submitted" delayTime={2500} />}
		</section>
		</>
	);
};

export default Contact;
